import React, {Component} from 'react';
import PropTypes from "prop-types";
import PageLinksContainer from "../../utils/PageLinksContainer";

class AdminContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    getPageLinks() {

        const pageLinks = [];

        if (this.props.baseData.checkUserRole('superadmin')) {
            pageLinks.push({
                header: this.translate('licence'),
                classes: 'adminLicence',
                src: require('../../img/nav/sidenav/web/licence-default.svg').default,
                link: 'adminLicence',
            }, {
                header: this.translate('companies'),
                classes: 'companies',
                src: require('../../img/nav/sidenav/web/companies-default.svg').default,
                link: 'adminCompanies',
            }, {
                header: this.translate('locations'),
                classes: 'locations',
                src: require('../../img/nav/sidenav/web/locations-default.svg').default,
                link: 'adminLocations',
            }, {
                header: this.translate('machines'),
                classes: 'machines',
                src: require('../../img/nav/sidenav/web/machines-default.svg').default,
                link: 'adminMachines',
            }, {
                header: this.translate('user'),
                classes: 'user',
                src: require('../../img/nav/sidenav/web/users-default.svg').default,
                link: 'adminUsers',
            }, {
                header: this.translate('operator'),
                classes: 'operator',
                src: require('../../img/nav/sidenav/web/operators-default.svg').default,
                link: 'adminOperator',
            }, {
                header: this.translate('token'),
                classes: 'token',
                src: require('../../img/nav/sidenav/web/token-default.svg').default,
                link: 'adminOperatorToken',
            }, {
                header: this.translate('dataCollector'),
                classes: 'adminDatacollector',
                src: require('../../img/nav/sidenav/web/datacollector-cloud.svg').default,
                link: 'adminDatacollector',
            }, {
                header: this.translate('oldData'),
                classes: 'adminOldData',
                src: require('../../img/nav/sidenav/web/machines-default.svg').default,
                link: 'adminOldData',
            }, {
                header: this.translate('treeStructure'),
                classes: 'adminTreeStructure',
                src: require('../../img/nav/sidenav/web/software-default.svg').default,
                link: 'adminTreeStructure',
            }, {
                header: this.translate('sensors'),
                classes: 'adminSensors',
                src: require('../../img/nav/sidenav/web/miniserver-default.svg').default,
                link: 'adminSensors',
            }, {
                header: this.translate('logFiles'),
                classes: 'adminLogs',
                src: require('../../img/nav/sidenav/web/logfiles-default.svg').default,
                link: 'adminLogs',
            }, {
                header: this.translate('rawData'),
                classes: 'adminRawData',
                src: require('../../img/nav/sidenav/web/logfiles-default.svg').default,
                link: 'adminRawData',
            });
        } else if (this.props.baseData.checkUserRole('zskadmin')) {
            pageLinks.push({
                header: this.translate('licence'),
                classes: 'adminLicence',
                src: require('../../img/nav/sidenav/web/licence-default.svg').default,
                link: 'adminLicence',
            }, {
                header: this.translate('companies'),
                classes: 'companies',
                src: require('../../img/nav/sidenav/web/companies-default.svg').default,
                link: 'adminCompanies',
            }, {
                header: this.translate('locations'),
                classes: 'locations',
                src: require('../../img/nav/sidenav/web/locations-default.svg').default,
                link: 'adminLocations',
            }, {
                header: this.translate('machines'),
                classes: 'machines',
                src: require('../../img/nav/sidenav/web/machines-default.svg').default,
                link: 'adminMachines',
            }, {
                header: this.translate('user'),
                classes: 'user',
                src: require('../../img/nav/sidenav/web/users-default.svg').default,
                link: 'adminUsers',
            }, {
                header: this.translate('operator'),
                classes: 'operator',
                src: require('../../img/nav/sidenav/web/operators-default.svg').default,
                link: 'adminOperator',
            }, {
                header: this.translate('token'),
                classes: 'token',
                src: require('../../img/nav/sidenav/web/token-default.svg').default,
                link: 'adminOperatorToken',
            }, {
                header: this.translate('dataCollector'),
                classes: 'adminDatacollector',
                src: require('../../img/nav/sidenav/web/datacollector-cloud.svg').default,
                link: 'adminDatacollector',
            }, {
                header: this.translate('oldData'),
                classes: 'adminOldData',
                src: require('../../img/nav/sidenav/web/machines-default.svg').default,
                link: 'adminOldData',
            }, {
                header: this.translate('rawData'),
                classes: 'adminRawData',
                src: require('../../img/nav/sidenav/web/logfiles-default.svg').default,
                link: 'adminRawData',
            });
        } else if (this.props.baseData.checkUserRole('companyadmin')) {
            pageLinks.push({
                header: this.translate('licence'),
                classes: 'adminLicence',
                src: require('../../img/nav/sidenav/web/licence-default.svg').default,
                link: 'adminLicence',
            }, {
                header: this.translate('locations'),
                classes: 'locations',
                src: require('../../img/nav/sidenav/web/locations-default.svg').default,
                link: 'adminLocations',
			}, {
				header: this.translate('machines'),
				classes: 'machines',
				src: require('../../img/nav/sidenav/web/machines-default.svg').default,
				link: 'adminMachines',
            }, {
                header: this.translate('user'),
                classes: 'user',
                src: require('../../img/nav/sidenav/web/users-default.svg').default,
                link: 'adminUsers',
            }, {
                header: this.translate('operator'),
                classes: 'operator',
                src: require('../../img/nav/sidenav/web/operators-default.svg').default,
                link: 'adminOperator',
            }, {
                header: this.translate('token'),
                classes: 'token',
                src: require('../../img/nav/sidenav/web/token-default.svg').default,
                link: 'adminOperatorToken',
            }, {
                header: this.translate('dataCollector'),
                classes: 'adminDatacollector',
                src: require('../../img/nav/sidenav/web/datacollector-cloud.svg').default,
                link: 'adminDatacollector',
            }, {
                header: this.translate('rawData'),
                classes: 'adminRawData',
                src: require('../../img/nav/sidenav/web/logfiles-default.svg').default,
                link: 'adminRawData',
            });
        }

        return pageLinks;

    }

    render() {

        const pageLinks = this.getPageLinks();

        return (
            <div className="adminContainer">
                <nav>
                    <h1>{this.translate('adminPageHeader')}</h1>
                </nav>

                <PageLinksContainer
                    pageLinks={pageLinks}
                    pageNavigation={this.props.baseData.pageNavigation}
                />
            </div>
        );

    }

}

export default AdminContainer;